module.exports = __webpack_public_path__ + "static/media/5_ratings_icon.8f602a59.svg";